import React from 'react';
import { FaPlay, FaPause } from 'react-icons/fa';

import { meal } from '../../constants';
import './Intro.css';

const Intro = () => {
  const [playing, setPlaying] = React.useState(true);
  const vidRef = React.useRef(null);

  const togglePlay = () => {
    if (!vidRef.current) return;
    if (playing) {
      vidRef.current.pause();
    } else {
      vidRef.current.play();
    }
    setPlaying(!playing);
  };

  return (
    <div className="section--sand app__video-section">
      <div className="app__container">
        <div className="app__video">
          <video
            ref={vidRef}
            src={meal}
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          />
          <button
            type="button"
            className="app__video-toggle"
            onClick={togglePlay}
            aria-label={playing ? 'Pausa video' : 'Riproduci video'}
          >
            {playing ? <FaPause /> : <FaPlay />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Intro;
